const FaqsData = [
  {
    question: "Do you offer job placement assistance?",
    answer:
      "Yes, we provide resume reviews, interview prep, and job placement support to help you secure opportunities.",
  },
  {
    question: "What courses do you offer?",
    answer:
      "We offer UI/UX Design, Data Analysis, Data Science, Mobile Development, and Web Development training programs.",
  },
  {
    question: "Who can join these courses?",
    answer:
      "Our courses are designed for beginners, intermediates, and professionals. No prior experience is required for most courses.",
  },
  {
    question: "Are the courses online or in-person?",
    answer:
      "We offer online training that allows you to learn from anywhere with flexible schedules and expert guidance.",
  },
  {
    question: "How long are the courses?",
    answer:
      "Courses typically range from 6 to 8 weeks, depending on the program and learning pace of students.",
  },
  {
    question: "What is the cost of the courses?",
    answer:
      "Prices vary by course, except for our bootcamp series, which offers a uniform price. Visit our Bootcamp page for details.",
  },
  {
    question: "Will I receive a certificate?",
    answer:
      "Yes, you’ll receive a certificate of completion after successfully finishing the course requirements.",
  },
  {
    question: "Do I need prior experience for UI/UX Design?",
    answer:
      "No, the UI/UX Design course is beginner-friendly. We teach from the basics and gradually move to advanced concepts.",
  },
  {
    question: "What tools will I learn in Data Analysis?",
    answer:
      "You’ll gain hands-on experience with Excel, SQL, Python, and Power BI for data analysis and visualization.",
  },
  {
    question: "What prerequisites are needed for Data Science?",
    answer:
      "Basic knowledge of Python and math is helpful, but not required. We cover fundamentals before advancing.",
  },
  {
    question: "What languages are taught in Web Development?",
    answer:
      "You’ll learn HTML, CSS, PHP, JavaScript, and frameworks like React and Laravel to build dynamic websites.",
  },
  {
    question: "How do I enroll in a course?",
    answer:
      "Visit our website, select your desired course, and click 'Enroll Now' to complete the registration process.",
  },
  {
    question: "What is the refund policy?",
    answer:
      "We offer a full refund if you cancel within 4 days. Send a cancellation request to info@nexatrux.com.",
  },
  {
    question: "What if I miss a class?",
    answer:
      "All sessions are recorded and made available for replay so you can catch up at your own convenience.",
  },
  {
    question: "When does the new cohort start?",
    answer:
      "Registration opens 3 weeks after the previous one. The date for the new cohort will be updated on the website and on all our social media handles.",
  },
  {
    question: "How can I contact the bootcamp team for further inquiries?",
    answer:
      "You can reach us at nexatrux@gmail.com , +234 815 444 4342 , +2348105283900 ",
  },
];
export default FaqsData;
